import React from 'react';
import styled from 'styled-components/macro';

import ForecastQueryRenderer from '../../../ForecastQueryRenderer';
import ProjectPortfolioReportCharts, {ProjectPortfolioReportChartsQuery} from './ProjectPortfolioReportCharts';
import {filtersToSearchQuery} from './ProjectPortfolioReportUtils';
import {OutlineBox, Section} from './ProjectPortfolioReport.styled';

const ProjectPortfolioReportChartsQueryRendererStyle = styled.div`
	height: 300px;
`;

export const ProjectPortfolioReportChartsQueryRenderer = ({
	selectedSingleValue,
	filterValue,
	selectedDateRange: {startDate, endDate},
	hasFinance,
}) => {
	if (!hasFinance) {
		return null;
	}

	const diffMonths = endDate.clone().add(1, 'day').diff(startDate, 'months');

	let aggregateLevel;
	if (diffMonths > 6) {
		aggregateLevel = 'MONTH';
	} else {
		aggregateLevel = 'DAY';
	}

	let aggregates = [];
	switch (selectedSingleValue) {
		case 'actualRevenue':
			aggregates.push('actualRevenue');
			break;
		case 'actualCost':
			aggregates.push('actualCost');
			break;
		case 'actualProfit':
			aggregates.push('actualProfit');
			break;
		case 'plannedRevenue':
			aggregates.push('plannedRevenue');
			break;
		case 'plannedCost':
			aggregates.push('plannedCost');
			break;
		case 'plannedProfit':
			aggregates.push('plannedProfit');
			break;
		case 'remainingRevenue':
			aggregates.push('remainingRevenue');
			break;
		case 'remainingCost':
			aggregates.push('remainingCost');
			break;
		case 'remainingProfit':
			aggregates.push('remainingProfit');
			break;
		case 'forecastRevenue':
			aggregates.push('actualRevenue', 'forecastRevenue');
			break;
		case 'forecastCost':
			aggregates.push('actualCost', 'forecastCost');
			break;
		case 'forecastProfit':
			aggregates.push('actualProfit', 'forecastProfit');
			break;
		case 'invoiced':
			aggregates.push('invoiced');
			break;
		case 'paid':
			aggregates.push('paid');
			break;
		case 'recognitionAmount':
			aggregates.push('recognitionAmount');
			break;
		default:
			throw new Error(`Unsupported selectedSingleValue ${selectedSingleValue}`);
	}

	return (
		<Section sticky marginLeft={24} marginRight={24}>
			<OutlineBox growable data-userpilot={'project-portfolio-report-charts'}>
				<ProjectPortfolioReportChartsQueryRendererStyle>
					<ForecastQueryRenderer
						key="query-render-projectPortfolioReportChartsQuery"
						componentName="project_portfolio_report_charts"
						query={ProjectPortfolioReportChartsQuery}
						variables={{
							searchQuery: filtersToSearchQuery(filterValue),
							startYear: startDate.year(),
							startMonth: startDate.month() + 1,
							startDay: startDate.date(),
							endYear: endDate.year(),
							endMonth: endDate.month() + 1,
							endDay: endDate.date(),
							aggregateLevel,
							aggregates,
						}}
						showLoader={true}
						render={relayProps => {
							return (
								<ProjectPortfolioReportCharts
									{...relayProps}
									selectedSingleValue={selectedSingleValue}
									aggregates={aggregates}
									aggregateLevel={aggregateLevel}
									startDate={startDate}
									endDate={endDate}
								/>
							);
						}}
					/>
				</ProjectPortfolioReportChartsQueryRendererStyle>
			</OutlineBox>
		</Section>
	);
};
